define('../../widgets/search-field/main',['jquery', 'utils/bind-manager', 'modules/pop-over', 'utils/url-hash-manager'], function (
  $,
  bindMng,
  PopOver,
  UrlHashManager
) {
  return function () {
    var SearchField = (function () {
      function SearchField(searchField) {
        this.destroyList = $.Deferred();
        this.hashManager = new UrlHashManager();

        this.searchField = searchField;
        this.form = searchField;
        this.input = this.form.find('input');
        this.button = this.form.find('button');
        this.isInNavigationBar = searchField.closest('.navigation-bar__actions').length;
        this.timeoutCallbackInputBlurred = false;

        if (this.isInProductFilter()) {
          this.initSearchFilter();
        }
      }

      SearchField.prototype.isShrinked = function () {
        return this.input.width() == 0;
      };

      SearchField.prototype.isInProductFilter = function () {
        if (this._isInProductFilter === undefined) {
          this._isInProductFilter = !!this.form.closest('.product-filter--listing').length;
        }
        return this._isInProductFilter;
      };

      SearchField.prototype.toggle = function () {
        this.popOver = this.factoryPopOver();
        if (!this.popOver.visible) {
          this.popOver.show(this.form);
          $('#search-query2').focus();
          //this.popOver.el.find('input').focus();
        } else {
          this.popOver.hide();
        }
      };

      SearchField.prototype.factoryPopOver = function () {
        if (this.popOver) {
          return this.popOver;
        }
        this.popOver = new PopOver(this.button, $('#search-pop-over'));
        var sf = new SearchField(this.popOver.el.find('.search-field'));
        sf.bind();

        return this.popOver;
      };

      SearchField.prototype.callbackInputFocused = function () {
        this.searchField.addClass('search-field--focused');
      };

      SearchField.prototype.callbackInputBlurred = function (timeout) {
        var _this = this;
        this.timeoutCallbackInputBlurred = setTimeout(
          function () {
            _this.searchField.removeClass('search-field--focused');
          },
          timeout ? timeout : 150
        );
      };

      // special case when the button is clicked
      SearchField.prototype.cancelCallbackInputBlurred = function () {
        if (this.timeoutCallbackInputBlurred) {
          clearTimeout(timeoutCallbackInputBlurred);
          this.timeoutCallbackInputBlurred = false;
        }
      };

      SearchField.prototype.bind = function () {
        this.bindFocus();
        this.bindBlur();
        this.bindButtonClick();
        this.bindSubmit();
      };

      SearchField.prototype.bindFocus = function () {
        var _this = this,
          callback = function (e) {
            if (_this.isInNavigationBar && _this.isShrinked()) {
              _this.toggle();
            } else {
              _this.callbackInputFocused();
            }
          };

        this.input.on('focus', callback);
        this.destroyList.done(function () {
          _this.input.off('focus', callback);
        });
      };

      SearchField.prototype.bindBlur = function () {
        var _this = this,
          callback = function (e) {
            _this.callbackInputBlurred();
          };

        this.input.on('blur', callback);
        this.destroyList.done(function () {
          _this.input.off('blur', callback);
        });
      };

      SearchField.prototype.bindButtonClick = function () {
        var _this = this,
          callback = function (e) {
            if (_this.isInNavigationBar && _this.isShrinked()) {
              _this.toggle();
              e.preventDefault();
            } else {
              _this.callbackInputBlurred(0);
            }
          };
        this.button.on('click', callback);
        this.destroyList.done(function () {
          _this.button.off('click', callback);
        });
      };

      SearchField.prototype.getValue = function () {
        return $.trim(this.input.val());
      };

      SearchField.prototype.bindSubmit = function () {
        var _this = this,
          callback = function (e) {
            e.preventDefault();

            if (_this.isInProductFilter()) {
              _this.updateSearchFilter();
            } else {
              var value = _this.getValue(),
                url = _this.form.prop('action');

              if (value.length) {
                url += '#q=' + encodeURI(_this.input.val());
              }

              window.location.href = url;
              $(window).one('hashchange', function () {
                window.location.reload();
              });
            }
          };

        this.form.on('submit', callback);
        this.destroyList.done(function () {
          this.form.off('submit', callback);
        });
      };

      SearchField.prototype.initSearchFilter = function () {
        if (this.isInProductFilter()) {
          var query = this.hashManager.get('q'),
            _this = this;
          if (query) {
            this.input.val(query);
            this.updateSearchFilter();
          }

          this.searchField.on('clear', function () {
            _this.clearSearchFilter();
          });
        }
      };

      SearchField.prototype.updateSearchFilter = function () {
        var queryValue = this.getValue();

        if (queryValue.length) {
          this.hashManager.add('q', [queryValue]);
        } else {
          this.hashManager.remove('q');
        }
        this.searchField.trigger('searchChanged', queryValue);
      };

      SearchField.prototype.clearSearchFilter = function () {
        this.input.val('');
        this.hashManager.remove('q');
        this.searchField.trigger('searchChanged', '');
      };

      SearchField.prototype.destroy = function () {
        this.destroyList.resolve();
        this.searchField.remove();
      };

      return SearchField;
    })();

    $('[data-search]').each(function (i) {
      var sf = new SearchField($(this));
      sf.bind();
    });

    return SearchField;
  };
});

